import adminApiClient from '../../api/base/adminApiClient'

export interface DefaultReviewCategory {
  id: number
  name: string
  order: number
  created_at: string
  updated_at: string
}

export interface GetDefaultReviewCategoriesResponse {
  data: DefaultReviewCategory[]
}

export interface CreateDefaultReviewCategoryRequest {
  name: string
  order?: number
}

export interface CreateDefaultReviewCategoryResponse {
  message: string
  data: DefaultReviewCategory
}

export interface UpdateDefaultReviewCategoryRequest {
  name?: string
  order?: number
}

export interface UpdateDefaultReviewCategoryResponse {
  message: string
  data: DefaultReviewCategory
}

export interface DeleteDefaultReviewCategoryResponse {
  message: string
}

export const adminDefaultReviewCategoryApi = {
  getDefaultReviewCategories:
    async (): Promise<GetDefaultReviewCategoriesResponse> => {
      const response =
        await adminApiClient.get<GetDefaultReviewCategoriesResponse>(
          '/admin/default-review-categories'
        )
      return response.data
    },

  createDefaultReviewCategory: async (
    data: CreateDefaultReviewCategoryRequest
  ): Promise<CreateDefaultReviewCategoryResponse> => {
    const response =
      await adminApiClient.post<CreateDefaultReviewCategoryResponse>(
        '/admin/default-review-categories',
        data
      )
    return response.data
  },

  updateDefaultReviewCategory: async (
    id: number,
    data: UpdateDefaultReviewCategoryRequest
  ): Promise<UpdateDefaultReviewCategoryResponse> => {
    const response =
      await adminApiClient.put<UpdateDefaultReviewCategoryResponse>(
        `/admin/default-review-categories/${id}`,
        data
      )
    return response.data
  },

  deleteDefaultReviewCategory: async (
    id: number
  ): Promise<DeleteDefaultReviewCategoryResponse> => {
    const response =
      await adminApiClient.delete<DeleteDefaultReviewCategoryResponse>(
        `/admin/default-review-categories/${id}`
      )
    return response.data
  },
}
